// import { width } from '@mui/system'
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflowY: "auto",
  },
  form: {
    display: "flex",
    alignItems: "center",
    marginTop: 10,
    flexDirection: "column",
    //
    width: "100%",
  },
  divider: {
    width: "100%",
    alignItems: "center",
    color: "#B7B7B7",
  },
  dividerText: {
    color: theme.palette.text.secondary,
  },
  style: {
    width: "100%",
  },
}));

export default useStyles;
